import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Button, Grid } from "@material-ui/core";
import * as styles from "./styles.scss";

import { SvgIcon } from "../../../../../components";

import { numberMorfform, plural, tl } from "../../../../../utils";
import { MUIDialog, Theme } from "../../../MUI";
import FSStore from "../../store";
import FSCourseStore from "../store";
import FSNotifierStore from "../../../../../components/Notifier/store";

export const AttachPanel = observer(() => {
  const { fsStore, fsCourseStore, fsNotifierStore } = React.useContext<{fsStore: FSStore, fsCourseStore: FSCourseStore, fsNotifierStore: FSNotifierStore}>(MobXProviderContext);
  const [deleteModal, setDeleteModal] = React.useState<'all' | 'selected' | null>(null);

  const handleDeleteFiles = async () => {
    setDeleteModal(null);
    try {
     await fsStore.removeFiles(deleteModal === 'all')
     fsNotifierStore.addNotice(tl('Удаление успешно'), 'success')
    } catch (error) {
     fsNotifierStore.addNotice(tl('Произошла ошибка'), 'error')
      
    }
  }
  
  return fsStore.onProtect ||
    fsCourseStore.isFileslistGrouped ||
    fsStore.onCancel ||
    fsStore.onAttach || fsStore.canDelete ? (
    <Box
      bgcolor={Theme.palette.background.paper}
      className={`modal_fileselect-panel ${styles.panel}`}
    >
      <Box py={1.5} px={2}>
        <Grid container spacing={2} justifyContent="flex-end">
          {fsStore.onProtect || fsCourseStore.isFileslistGrouped ? (
            <Grid item xs={12} sm>
              <Grid container spacing={2} wrap="wrap">
                {fsStore.onProtect ? (
                  <Grid item>
                    <Button
                      variant="contained"
                      onClick={fsStore.onProtect.bind(this)}
                      startIcon={
                        <SvgIcon
                          type="fs-button-protector"
                          modifier="protected"
                        />
                      }
                    >
                      {tl("Защитить")}
                    </Button>
                  </Grid>
                ) : null}
                {fsCourseStore.isFileslistGrouped ? (
                  <Grid item xs={12} sm="auto">
                    <Button
                      variant="contained"
                      onClick={fsCourseStore.onToggleGroups}
                    >
                      {fsCourseStore.isFileslistExpanded
                        ? tl("Свернуть все уроки")
                        : tl("Развернуть все уроки")}
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          ) : null}
          {fsStore.onCancel || fsStore.onAttach ? (
            <Grid item xs={12} sm="auto">
              <Grid container spacing={2} justifyContent="space-between">
                {fsStore.onCancel ? (
                  <Grid item>
                    <Button variant="contained" onClick={fsStore.onCancel}>
                      {tl("Отмена")}
                    </Button>
                  </Grid>
                ) : null}

                {fsStore.onAttach && fsCourseStore.filterFilesType !=='transcription' ? (
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        fsStore.onAttachAll();
                      }}
                      disabled={!fsStore.getCheckedFilesCount}
                    >
                      {tl("Добавить ")}
                      {fsStore.getCheckedFilesCount}
                      {numberMorfform(
                        fsStore.getCheckedFilesCount,
                        tl(" файл"),
                        tl(" файла"),
                        tl(" файлов")
                      )}
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          ) : null}
          {fsStore.canDelete && fsCourseStore?.filesSectionTab === 'notinlessons'  && (
              <Grid item xs={12} sm="auto">
              <Grid container spacing={2} justifyContent="flex-end">
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setDeleteModal('all')
                      }}
                      disabled={!fsStore.filesCount}
                    >
                      {tl("Удалить все")}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setDeleteModal('selected')

                      }}
                      disabled={!fsStore.getCheckedFilesCount}
                    >
                      {tl("Удалить выбранные файлы")}
                      {/* {fsStore.getCheckedFilesCount}
                      {numberMorfform(
                        fsStore.getCheckedFilesCount,
                        tl(" файл"),
                        tl(" файла"),
                        tl(" файлов")
                      )} */}
                    </Button>
                  </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>
      <MUIDialog 
        open={!!deleteModal} 
        title={
          deleteModal === 'all' ? tl('Вы собираетесь удалить все файлы') : plural('Вы собираетесь удалить файлы (%d)', fsStore.getCheckedFilesCount)
        }
        onClose={() => setDeleteModal(null)}
        actions={[[], [
          {
            label: tl('Удалить'),
            btnProps: {
              color: 'default',
              variant: 'contained',
              onClick: () => {
                handleDeleteFiles();
              }
            }
          },
          {
            label: tl('Отменить'),
            btnProps: {
              color: 'primary',
              variant: 'contained',
              onClick: () => {
                setDeleteModal(null);
              }
            }
          }
        ]]}
      >
        <p>{deleteModal === 'all' ? tl('Отменить удаление будет невозможно, вы точно хотите удалить ВСЕ файлы?') :tl('Отменить удаление будет невозможно, вы точно хотите удалить выбранные файлы?')}</p>
      </MUIDialog>
    </Box>
  ) : null;
});
